export const requiredErrorMessage = 'Это поле обязательно для заполнения';
export const maxLengthErrorMessage = (length = 100) => `Максимальная длина - ${length} символов`;
export const statusMap: { [key: string]: string } = {
  success: 'Успешно обработана',
  error: 'Ошибка операции',
  processing: 'В процессе',
};
export enum HTTP_METHODS {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export enum CountrySelectId {
  KZ = 1,
  UZ = 4,
  KG = 3,
  Empty = 99999,
}
